import { render, staticRenderFns } from "./personnelClass.vue?vue&type=template&id=5551ed4f&"
import script from "./personnelClass.vue?vue&type=script&lang=js&"
export * from "./personnelClass.vue?vue&type=script&lang=js&"
import style0 from "./personnelClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports